export const name = 'stIcp';
export default function stIcp(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
    },
    template: require('./icp.jade'),
    link: icpLink,
    controller: icpController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////
  
  function icpLink(scope, element, attrs) {
  }

  /** @ngInject */
  function icpController(
    rnClient,
    $location
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;
    //   VM properties
    vm.showIcp = $location.host().endsWith('.cn');
    vm.icp = null;
    //   VM methods

    vm.$onInit = onInit;
    return;

    ///////////////
    // Init
    function onInit() {
      rnClient.getConfig().then(clientConfig => {
        vm.icp = _.get(clientConfig, 'registry.keys.icp');
      });
    }

    ///////////////
    // VM methods

    ///////////////
    // Helpers
  }
}



// WEBPACK FOOTER //
// ./components/icp/icp.directive.js